import { Inject, Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';
import { CWT_APP_CONFIG, CwtAppConfig } from '@mobile/modules/core/core-app.config';

@Injectable({ providedIn: 'root' })
export class DeepLinkService {
    constructor(
        @Inject(CWT_APP_CONFIG) private appConfig: CwtAppConfig,
        private router: Router,
        private zone: NgZone
    ) { }

    public async init() {
        if (!this.appConfig.deeplink.enable) return;
        const launchUrl = await App.getLaunchUrl();
        if (launchUrl?.url) this.zone.run(() => this._handleURL(launchUrl.url));
        await App.addListener('appUrlOpen', (event) => {
            this.zone.run(() => this._handleURL(event.url));
        });
    }

    private _handleURL(urlString: string) {
        const url = this._parseURL(urlString);
        if (!url) return;
        const pathWithoutDomain = url.href.replace(`${url.protocol}//${url.host}`, '')
        this.zone.run(() => this.router.navigateByUrl(pathWithoutDomain, {
            replaceUrl: true
        }));
    }

    private _parseURL(urlString: string) {
        try {
            return new URL(urlString);
        } catch (_e) {
            return null;
        }
    }
}